import { Phone } from 'lucide-react';
import { trackPhoneClick } from '../lib/analytics';

export const StickyCallButton = () => {
  return (
    <a
      href="tel:+491631945793"
      data-testid="sticky-call-button"
      onClick={() => trackPhoneClick()}
      className="fixed bottom-6 left-6 z-50 flex items-center gap-3 bg-gradient-to-r from-[#F1D27A] via-[#D4AF37] to-[#8F6B1F] text-black font-bold px-5 py-3 rounded-full shadow-lg shadow-[#D4AF37]/30 hover:scale-105 transition-transform duration-300 md:hidden"
      aria-label="Jetzt anrufen"
    >
      <Phone className="w-5 h-5" />
      <span className="text-sm">Anrufen</span>
    </a>
  );
};
